import config from 'common/config';
import apiClient from 'common/api/apiClient';

const client = {

    loadAllUser: (params) => {
        const url = `${config.api.LOGIN_URL}/userManage/getAllUser`;
        return apiClient.post(url,params);
    },

    getUser: () => {
        const url = `${config.api.LOGIN_URL}/userManage/getUser`;
        return apiClient.post(url);
    },

    submitUser: (params) => {
        const url = `${config.api.AUTH_URL}/userManage/submitUser`;
        return apiClient.post(url,params);
    },

    getUserAccountChangeLog: (params) => {
        const url = `${config.api.LOGIN_URL}/userManage/getUserAccountChangeLog`;
        return apiClient.post(url,params);
    },

    getUserAccountAccessLog: (params) => {
        const url = `${config.api.AUTH_URL}/userManage/getUserAccessLog`;
        return apiClient.post(url,params);
    },

    getPmManageList: (params) => {
        const url = `${config.api.LOGIN_URL}/userManage/getPmManageList`;
        return apiClient.post(url, params);
    },

    getRoleList: (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getRoleList`;
        return apiClient.post(url, params);
    },

    getPermissionList: (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getPermissionList`;
        return apiClient.post(url, params);
    },

    getRolePermissions: (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getRolePermissions`;
        return apiClient.post(url, params);
    },

    getUserAllPermissionList: (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getUserAllPermissionList`;
        return apiClient.post(url, params);
    },

    getUserDataAccessPermissions: (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getUserDataAccessPermissions`;
        return apiClient.post(url, params);
    },

    saveUserRole: (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/saveUserRole`;
        return apiClient.post(url, params);
    },

    saveRolePermission: (params) => {
        const url = `${config.api.AUTH_URL}/permissionManage/saveRolePermission`;
        return apiClient.post(url, params);
    },

    getAllDataAccessPermissions: () => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getAllDataAccessPermissions`;
        return apiClient.post(url);
    },

    savePermissions : (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/savePermissions`;
        return apiClient.post(url, params);
    },

    getPermissions : (params) => {
        const url = `${config.api.LOGIN_URL}/permissionManage/getPermissions`;
        return apiClient.post(url, params);
    },

    getAllUserApplications : (params) => {
        const url = `${config.api.LOGIN_URL}/userManage/getAllUserApplications`;
        return apiClient.post(url, params);
    },

    selectCostInfoByEnglishName : (params) => {
        const url = `${config.api.LOGIN_URL}/userManage/selectCostInfoByEnglishName`;
        return apiClient.post(url, params);
    },

    saveCostInfo : (params) => {
        const url = `${config.api.LOGIN_URL}/userManage/saveCostInfo`;
        return apiClient.post(url, params);
    },

    getSignRecords: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/getSignRecords`;
        return apiClient.post(url, params);
    },

    getAllSignRecords: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/getAllSignRecords`;
        return apiClient.post(url, params);
    },

    signIn: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/sign`;
        return apiClient.post(url, params);
    },

    getLeaveRecords: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/getLeaveRecords`;
        return apiClient.post(url, params);
    },

    saveLeaveRecord: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/saveLeaveRecord`;
        return apiClient.post(url, params);
    },

    getUserClockApplyRecordList: () => {
        const url = `${config.api.LOGIN_URL}/userSign/getUserClockApplyRecordList`;
        return apiClient.post(url);
    },

    getSelfClockApplyRecordList: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/getSelfClockApplyRecordList`;
        return apiClient.post(url, params);
    },

    applyClockHours: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/applyClockHours`;
        return apiClient.post(url, params);
    },

    verifyClockHours: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/verifyClockHours`;
        return apiClient.post(url, params);
    },

    getUserClockConfig: () => {
        const url = `${config.api.LOGIN_URL}/userSign/getUserClockConfig`;
        return apiClient.post(url);
    },

    verifySign: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/verifySign`;
        return apiClient.post(url, params);
    },

    signList: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/signList`;
        return apiClient.post(url, params);
    },

    getJapanUserList: () => {
        const url = `${config.api.LOGIN_URL}/userSign/getJapanUserList`;
        return apiClient.post(url);
    },

    getAllLeaveRecordAndHoliday: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/getAllLeaveRecordAndHoliday`;
        return apiClient.post(url, params);
    },

    disableClockByAdmin: (params) => {
        const url = `${config.api.LOGIN_URL}/userSign/disableClockByAdmin`;
        return apiClient.post(url, params);
    },
};

export default client;
